import * as _ from 'underscore';
import { GetExtractEncryptionStatsRequest, IGetExtractEncryptionStatsResult } from '../../ts/ServerApi/requests/GetExtractEncryptionStatsRequest';
import { IPoller, PollService } from '../../ts/services/PollService';
import { ServiceLocator } from '../../app/ServiceLocator';

let statusPoller: IPoller<IGetExtractEncryptionStatsResult>;

function pollExtractEncryptionStats(siteId: string): ng.IPromise<any> {
  const isComplete = (result: IGetExtractEncryptionStatsResult): boolean => {
    return result && result.counts && result.counts.encrypting === 0 && result.counts.decrypting === 0;
  };
  const pollService = ServiceLocator.get<PollService>('PollService');
  statusPoller = pollService.poll(new GetExtractEncryptionStatsRequest({id: siteId}), isComplete, this.extractEncryptionStatusInterval);
  return statusPoller.promise;
}

function cancelExtractEncryptionStatsPolling() {
  if(!_.isUndefined(statusPoller)) {
    statusPoller.cancel();
  }
}

export const ExtractEncryptionService = {
  pollExtractEncryptionStats,
  cancelExtractEncryptionStatsPolling
};

export type ExtractEncryptionService = typeof ExtractEncryptionService;
